import { render, staticRenderFns } from "./wxhealthplan.vue?vue&type=template&id=e0e28742&scoped=true&"
import script from "./wxhealthplan.vue?vue&type=script&lang=js&"
export * from "./wxhealthplan.vue?vue&type=script&lang=js&"
import style0 from "./wxhealthplan.vue?vue&type=style&index=0&id=e0e28742&lang=scss&scoped=true&"
import style1 from "./wxhealthplan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e28742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0e28742')) {
      api.createRecord('e0e28742', component.options)
    } else {
      api.reload('e0e28742', component.options)
    }
    module.hot.accept("./wxhealthplan.vue?vue&type=template&id=e0e28742&scoped=true&", function () {
      api.rerender('e0e28742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxhealthplan.vue"
export default component.exports